/**
 * F-178 criterion 7: the navigations that still load a new page (a reload
 * after a purchase, a version update, an edit conflict, an external redirect)
 * stop the podcast explicitly instead of cutting it mid-sentence: the position
 * goes to the server first (keepalive) and the audio pauses. After a reload
 * the mini-player comes back paused at that point.
 *
 * Everything that only changes the screen goes through `navigate()` and never
 * reloads; this is only for the leftovers that must load a page.
 */

let stopActivePlayer: (() => void) | null = null

/** The mounted player registers its stop; returns the cleanup. */
export const registerActivePlayer = (stop: () => void): (() => void) => {
  stopActivePlayer = stop
  return () => {
    if (stopActivePlayer === stop) stopActivePlayer = null
  }
}

/** Pauses the podcast and saves where it stopped (a no-op with nothing playing). */
export const stopPlayerBeforeLeaving = (): void => {
  try {
    stopActivePlayer?.()
  } catch {
    /* Leaving anyway. */
  }
}

/** `window.location.reload()`, with the podcast stopped first. */
export const reloadPage = (): void => {
  stopPlayerBeforeLeaving()
  window.location.reload()
}

/** `window.location.assign(url)` to a page that replaces this one, with the podcast stopped first. */
export const leavePageTo = (url: string): void => {
  stopPlayerBeforeLeaving()
  window.location.assign(url)
}
